exports['arrow'] = require('./arrow')
exports['clock'] = require('./clock')
exports['pizza-full'] = require('./pizza-full')
exports['pizza-left'] = require('./pizza-left')
exports['pizza-right'] = require('./pizza-right')
exports['plus'] = require('./plus')
exports['ALLOWED_ICONS'] = require('./ALLOWED_ICONS');
